import {
    CheckCircle,
    ArrowRight,
    UserPlus,
    Search,
    Phone,
    MessageCircle,
    QrCode
} from 'lucide-react';
import './TutorialPage.css';

export default function TutorialPage() {
    const handleClose = () => {
        try {
            if ((window as any).liff) (window as any).liff.closeWindow();
        } catch (e) {
            console.log('Not in LIFF');
        }
    };

    return (
        <div className="tutorial-page-story scroll-y">

            {/* Section 1: Header */}
            <header className="hero-header">
                <h1 className="hero-title">การใช้งานเบื้องต้น</h1>
                <p className="hero-sub">ให้ "ตังค์ตุง" ช่วยดูแลเรื่องเงินๆ ทองๆ นะครับ</p>
                <div className="mascot-hero-wrapper">
                    <div className="speech-bubble">มามะ! ให้ฉันช่วยนะ! 🐰</div>
                    <img
                        src="/Slimp.png"
                        className="mascot-hero"
                        alt="TangTung"
                        style={{ objectFit: 'contain' }}
                    />
                </div>
            </header>

            {/* Section 2: Step 1 - MiniPOS */}
            <section className="step-section">
                <div className="step-num">1</div>
                <h2 className="step-title">คิดเงินไว สร้าง QR ได้ทันที</h2>
                <p className="step-desc">
                    เปิด <b>MiniPOS</b> จิ้มราคาได้เลย<br />
                    สะดวกเหมือนเครื่องคิดเลข กดปุ่ม <b>"สร้าง QR"</b><br />
                    เพื่อให้ลูกค้าสแกนจ่ายได้ทันที
                </p>
                <div className="phone-mock-iso">
                    <div className="notch"></div>
                    <div className="screen-content" style={{ background: '#f8f9fa', display: 'flex', flexDirection: 'column' }}>
                        {/* Mock Calculator UI */}
                        <div style={{ background: 'white', padding: '20px', margin: '20px 10px', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
                            <div style={{ fontSize: '32px', fontWeight: 'bold', textAlign: 'right', marginBottom: '20px', color: '#333' }}>150.00</div>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px' }}>
                                {['7', '8', '9', 'C', '4', '5', '6', '+', '1', '2', '3', '-'].map(btn => (
                                    <div key={btn} style={{ background: '#edf2f7', borderRadius: '8px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>{btn}</div>
                                ))}
                            </div>
                            <button style={{ width: '100%', background: '#007AFF', color: 'white', border: 'none', padding: '12px', borderRadius: '12px', marginTop: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', fontWeight: 'bold' }}>
                                <QrCode size={18} /> สร้าง QR รับเงิน
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 3: Step 2 - Receive Notification */}
            <section className="step-section alternate">
                <div className="step-num">2</div>
                <h2 className="step-title">สแกนปุ๊บ รู้ปั๊บ!</h2>
                <p className="step-desc">
                    เมื่อลูกค้าสแกนจ่ายเงินสำเร็จ<br />
                    น้องตังค์ตุงจะส่ง <b>แจ้งเตือน + สลิป</b> เข้าไลน์ให้ทันที<br />
                    ไม่ต้องคอยถามลูกค้าว่า "โอนยัง?"
                </p>

                <div className="phone-mock-iso">
                    <div className="notch"></div>
                    <div className="screen-content mock-chat">
                        <div style={{ textAlign: 'center', fontSize: '10px', color: '#aaa', margin: '10px 0' }}>Today 12:30 PM</div>
                        {/* Flex Message Mockup */}
                        <div className="chat-row">
                            <div className="avatar bot"><img src="/Slimp.png" style={{ width: '100%', height: '100%', borderRadius: '50%' }} /></div>
                            <div className="bubble left" style={{ padding: '0', overflow: 'hidden', width: '220px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                                {/* Header: Blue Theme */}
                                <div style={{ background: '#007AFF', padding: '12px', color: 'white', fontWeight: 'bold', fontSize: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <CheckCircle size={20} style={{ fill: 'white', stroke: '#007AFF' }} /> บันทึกสำเร็จ
                                </div>
                                {/* Body */}
                                <div style={{ padding: '20px 15px', background: 'white' }}>
                                    <div style={{ fontSize: '36px', fontWeight: '900', color: '#333', textAlign: 'center', marginBottom: '24px', letterSpacing: '-1px' }}>
                                        ฿ 200.00
                                    </div>

                                    <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: '15px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', color: '#888' }}>
                                            <span>ประเภท</span>
                                            <span style={{ color: '#333', fontWeight: '500', display: 'flex', alignItems: 'center', gap: '4px' }}>💵 เงินสด</span>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', color: '#888' }}>
                                            <span>วันที่</span>
                                            <span style={{ color: '#333', fontWeight: '500' }}>6 ก.พ. 2569</span>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', color: '#888' }}>
                                            <span>เวลา</span>
                                            <span style={{ color: '#333', fontWeight: '500' }}>11:04</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 4: Step 3 - AI Report & PDF */}
            <section className="step-section">
                <div className="step-num">3</div>
                <h2 className="step-title">อยากได้รายงาน.. แค่บอกมา! 🤖</h2>
                <p className="step-desc">
                    พิมพ์บอกน้องตังค์ตุง <b>"ขอรายงานเดือนนี้"</b><br />
                    AI จะสรุปยอดพร้อมส่งไฟล์ <b>PDF</b> ให้ทันที<br />
                    เอาไปยื่นภาษีหรือกู้ธนาคารได้เลย!
                </p>
                <div className="phone-mock-iso">
                    <div className="notch"></div>
                    <div className="screen-content mock-chat">
                        <div className="chat-row">
                            <div className="bubble right">ขอรายงานเดือนนี้ครับ</div>
                        </div>
                        <div className="chat-row" style={{ marginTop: '10px' }}>
                            <div className="avatar bot"><img src="/Slimp.png" style={{ width: '100%', height: '100%', borderRadius: '50%' }} /></div>
                            <div className="bubble left" style={{ padding: '0', overflow: 'hidden', width: '210px' }}>
                                <div style={{ background: '#007AFF', padding: '10px', color: 'white', fontWeight: 'bold' }}>ส่งรายงานให้แล้วครับ 📄</div>
                                <div style={{ padding: '15px', background: 'white' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', background: '#f5f5f5', padding: '10px', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                                        <div style={{ width: '32px', height: '40px', background: '#FF3B30', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '10px', fontWeight: 'bold', flexShrink: 0 }}>PDF</div>
                                        <div style={{ fontSize: '12px', color: '#333', minWidth: 0, flex: 1 }}>
                                            <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Report_Feb.pdf</div>
                                            <div style={{ color: '#888' }}>1.2 MB</div>
                                        </div>
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#666', marginTop: '10px', textAlign: 'center' }}>
                                        สรุปยอดขาย: ฿ 45,900
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 5: Step 4 - Add Staff (PRO) */}
            <section className="step-section alternate">
                <div className="step-num">4</div>
                <div style={{ display: 'inline-block', background: '#FFD700', padding: '4px 8px', borderRadius: '12px', fontSize: '10px', fontWeight: 'bold', color: 'black', marginBottom: '8px' }}>PRO Feature</div>
                <h2 className="step-title" style={{ marginTop: '0' }}>มีลูกน้อง.. ก็ช่วยกันขายได้!</h2>
                <p className="step-desc">
                    เพิ่มพนักงาน (Staff) เข้ามาช่วยขายง่ายๆ<br />
                    แค่กด <b>"เชิญพนักงาน"</b> แล้วเลือกเพื่อนใน LINE<br />
                    ไม่ต้องจำรหัสผ่าน แยกยอดขายรายคนได้ด้วย
                </p>
                <div className="phone-mock-iso">
                    <div className="notch"></div>
                    <div className="screen-content" style={{ background: '#f8f9fa', padding: '20px' }}>
                        {/* Fake Header */}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
                            <h3 style={{ margin: 0, fontSize: '18px' }}>จัดการทีม</h3>
                        </div>
                        {/* Staff List Mock */}
                        <div style={{ background: 'white', borderRadius: '12px', padding: '15px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', marginBottom: '15px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '15px' }}>
                                <div style={{ width: '40px', height: '40px', background: '#ddd', borderRadius: '50%' }}></div>
                                <div>
                                    <div style={{ fontWeight: 'bold', fontSize: '14px' }}>เจ้าของร้าน (คุณ)</div>
                                    <div style={{ fontSize: '12px', color: '#888' }}>Owner</div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <div style={{ width: '40px', height: '40px', background: '#e0f7fa', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>👷</div>
                                <div>
                                    <div style={{ fontWeight: 'bold', fontSize: '14px' }}>พนักงาน A</div>
                                    <div style={{ fontSize: '12px', color: '#888' }}>Staff</div>
                                </div>
                            </div>
                        </div>
                        {/* Invite Button Mock */}
                        <button style={{ width: '100%', background: '#34C759', color: 'white', border: 'none', padding: '12px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', fontWeight: 'bold', boxShadow: '0 4px 10px rgba(52, 199, 89, 0.3)' }}>
                            <UserPlus size={18} /> เชิญพนักงานเพิ่ม
                        </button>

                        {/* Floating Share Picker Hint */}
                        <div style={{ position: 'absolute', bottom: '60px', left: '10px', right: '10px', background: 'rgba(0,0,0,0.8)', padding: '10px', borderRadius: '8px', color: 'white', fontSize: '12px', textAlign: 'center', backdropFilter: 'blur(4px)' }}>
                            เลือกเพื่อนใน LINE ได้เลย! ✨
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 6: Step 5 - Dashboard */}
            <section className="step-section">
                <div className="step-num">5</div>
                <h2 className="step-title">ดูสรุปยอดแบบละเอียด</h2>
                <p className="step-desc">
                    กดเมนู <b>"ดูสรุปยอดขาย"</b> เพื่อดู Dashboard<br />
                    เห็นกราฟยอดขายรายวัน / รายเดือน ชัดเจน
                </p>
                <div className="phone-mock-iso">
                    <div className="notch"></div>
                    <div className="screen-content" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
                        <div className="summary-card" style={{ width: '100%', padding: '15px' }}>
                            <div style={{ fontSize: '14px', color: '#888', marginBottom: '5px' }}>ยอดขายเดือนนี้</div>
                            <div style={{ fontSize: '28px', fontWeight: '800', color: '#333' }}>฿ 45,900</div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', color: '#34C759', fontSize: '12px', marginTop: '5px' }}>
                                <div style={{ width: '16px', height: '16px', background: '#34C759', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>↑</div>
                                +12% จากเดือนที่แล้ว
                            </div>
                        </div>
                        <div style={{ width: '100%', height: '120px', background: 'white', borderRadius: '12px', marginTop: '15px', padding: '15px', display: 'flex', alignItems: 'flex-end', gap: '8px', justifyContent: 'space-between' }}>
                            {[40, 60, 30, 80, 50, 70, 90].map((h, i) => (
                                <div key={i} style={{ width: '100%', background: i === 6 ? '#007AFF' : '#eee', borderRadius: '4px', height: `${h}%` }}></div>
                            ))}
                        </div>
                        <img src="/Slimp.png" className="mascot-mini" style={{ bottom: '20px', right: '20px', width: '60px' }} />
                    </div>
                </div>
            </section>

            {/* Section 6: Contact Footer */}
            <footer className="footer-contact">
                <div className="footer-logo">
                    <img src="/Slimp.png" style={{ width: '60px' }} />
                </div>
                <h3 style={{ fontSize: '20px', marginBottom: '20px' }}>ติดต่อสอบถาม</h3>

                <div className="contact-info">
                    <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                        <Phone size={18} /> 02-123-4567
                    </p>
                    <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                        <MessageCircle size={18} /> LINE: @tangtung
                    </p>
                </div>

                <div style={{ marginTop: '40px', opacity: 0.6, fontSize: '12px' }}>
                    © 2024 TangTung App. All rights reserved.
                </div>

                <img src="/Slimp.png" className="footer-mascot" />
            </footer>

            {/* Start Button (Fixed) */}
            <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 100 }}>
                <button onClick={handleClose} style={{ background: '#007AFF', color: 'white', width: '60px', height: '60px', borderRadius: '50%', border: 'none', boxShadow: '0 4px 15px rgba(0,122,255,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px' }}>
                    🚀
                </button>
            </div>

        </div>
    );
}
